import { ArticleParagraph1, ArticleParagraph2, ArticleParagraph3, ArticleParagraph4 } from '../Article/ArticleParagraph';

/**
 * @deprecated используйте ArticleParagraph1 или UIText1
 */
export const Paragraph1 = ArticleParagraph1;

/**
 * @deprecated используйте ArticleParagraph2 или UIText2
 */
export const Paragraph2 = ArticleParagraph2;

/**
 * @deprecated используйте ArticleParagraph3 или UIText3
 */
export const Paragraph3 = ArticleParagraph3;

/**
 * @deprecated используйте Overline или кастомный CSS
 */
export const Paragraph4 = ArticleParagraph4;